<template>
  <section>
    <div class="standardSide1">
      <el-image :src="obj.cover_img" :preview-src-list="[obj.cover_img]">
      </el-image>
    </div>
  </section>
</template>

<script>
export default {
  name: "comDtoSide1",
  components: {},
  props: {
    obj: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {},
  watch: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.standardSide1 {
  display: flex;
  justify-content: center;
  > div {
    width: 96px;
    height: 118px;
    opacity: 0.3;
  }
}
</style>